<div class="roles-wrapper">
  <!-- ADD ROLE CARD -->
  <wm-add-role-janus
    *ngIf="showAddRoleCard && !selectedRole"
    (closeCard)="closeAddRole()"
    (saveRole)="saveNewRole($event)"
    (roleCreated)="onRoleCreated()"
  >
  </wm-add-role-janus>

  <!-- ROLE DETAILS VIEW -->
  <wm-role-details-janus
    *ngIf="selectedRole"
    [role]="selectedRole"
    (close)="closeRoleDetails()"
    [allPermissions]="allPermissions"
    (removeUser)="removeUser($event)"
    (save)="saveRole()"
   (delete)="deleteRole()"
  >
  </wm-role-details-janus>

  <!-- MAIN LIST PAGE -->
  <div class="roles-container" [class.disabled]="showAddRoleCard" *ngIf="!selectedRole">
    <!-- LOADING SKELETONS -->
    <div *ngIf="loading" class="loader-wrapper">
      <div class="vertical-loader" *ngFor="let _ of [].constructor(12)"></div>
    </div>

    <!-- ERROR MESSAGE -->
    <div *ngIf="error && !loading" class="error-wrapper">
      Failed to load roles
    </div>

    <!-- ROLES LIST -->
    <ng-container *ngIf="!loading && !error">
      <div class="roles-header">
        <wm-common-text
          [data]="{ text: 'Roles' }"
          class="roleheadertext"
        ></wm-common-text>

        <button class="add-role-btn" (click)="openAddRole()">
          ADD ROLE
        </button>
      </div>

      <div class="roles-grid">
        <div
          class="role-item"
          *ngFor="let r of roles"
          (click)="goToEdit(r)"

        >
          {{ r.name }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
